// extracted by mini-css-extract-plugin
export var formContainer = "_ii-0";
export var message = "_ii-1";